import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

export async function generatePdfFromHtmlPages(
  pages: HTMLElement[],
): Promise<{ blob: Blob; filename: string }> {
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'pt',
    format: 'a4',
  });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  for (let i = 0; i < pages.length; i += 1) {
    const canvas = await html2canvas(pages[i], {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
    });
    const image = canvas.toDataURL('image/jpeg', 0.95);
    if (i > 0) pdf.addPage('a4', 'portrait');
    pdf.addImage(image, 'JPEG', 0, 0, pageWidth, pageHeight);
  }

  const blob = pdf.output('blob');
  return { blob, filename: 'signed-contract.pdf' };
}

export async function generatePdfBlobFromContainer(
  container: HTMLElement | null,
  filename = 'signed-contract.pdf',
): Promise<{ blob: Blob; filename: string }> {
  const pages = Array.from(container?.children || []) as HTMLElement[];
  if (!pages.length) {
    throw new Error('没有可生成的票据页面');
  }
  const result = await generatePdfFromHtmlPages(pages);
  return { blob: result.blob, filename };
}
